import { createContext, useContext } from 'react';

import type { ExtendOrderContextValue } from 'pages/orders/extend_order/ExtendOrder';

export const ExtendOrderContext = createContext({} as ExtendOrderContextValue);
ExtendOrderContext.displayName = 'ExtendOrderContext';

export const useExtendOrder = () => useContext(ExtendOrderContext);